// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3QB1r","socialMedia":"styles_socialMedia__3vvMx"};